import { gql } from '@apollo/client';
import SPECIFICATION from './SPECIFICATION';
const MODELS_SHARED_WITH = gql `
  ${SPECIFICATION}
  fragment SharedWithSpecifications on UserNode {
    modelSpecificationsSharedWith(
      search: $search
      modelSpecification_Tags_TagId: $tags
      orderBy: $othersOrderBy
      first: $first
      after: $after
      modelSpecification_IsActive: $isActive
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          status
          modelSpecification {
            ...SpecificationFragment
          }
        }
      }
    }
  }
`;
export default MODELS_SHARED_WITH;
